<template>
  <div>
    <div class="head-card">
      <div class="head-card-top">
        <h4>{{ title }}</h4>
        <feather-icon
          v-b-tooltip.hover.top="$t('Close')"
          icon="XIcon"
          size="18"
          class="toggle-close cursor-pointer"
          @click="$router.push({ name: 'dashboard-user-google-ads', params: { userId: $route.params.userId } })"
        />
      </div>
      <hr>
      <div class="head-card-bottom pb-1">
        <b-button
          v-ripple.400="'rgba(40, 199, 111, 0.15)'"
          :variant="$route.name === 'dashboard-google-ads-stats' ? 'primary' : 'light-primary'"
          class="mr-1"
          :to="{ name: 'dashboard-google-ads-stats', params: { userId: $route.params.userId, adId: $route.params.adId } }"
        >
          <feather-icon
            icon="GlobeIcon"
            size="16"
            class="mr-50"
          />
          {{ $t('Statistics') }}
        </b-button>
        <b-button
          v-if="isAdmin"
          v-ripple.400="'rgba(40, 199, 111, 0.15)'"
          :variant="$route.name === 'dashboard-google-ads-events' ? 'primary' : 'light-primary'"
          class="mr-1"
          :to="{ name: 'dashboard-google-ads-events', params: { userId: $route.params.userId, adId: $route.params.adId } }"
        >
          <feather-icon
            icon="ActivityIcon"
            size="16"
            class="mr-50"
          />
          {{ $t('offerwall_events.title') }}
        </b-button>
        <b-button
          v-ripple.400="'rgba(40, 199, 111, 0.15)'"
          :variant="$route.name === 'dashboard-google-ads-edit' ? 'primary' : 'light-primary'"
          :to="{ name: 'dashboard-google-ads-edit', params: { userId: $route.params.userId, adId: $route.params.adId } }"
        >
          <feather-icon
            icon="SettingsIcon"
            size="16"
            class="mr-50"
          />
          {{ $t('Settings') }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import Ripple from 'vue-ripple-directive'
import { getUserData } from '@/auth/utils'
import {
  BButton,
  VBTooltip,
} from 'bootstrap-vue'

export default {
  components: {
    BButton,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  props: {
    title: {
      type: String,
      required: true,
      default: '',
    },
  },
  computed: {
    isAdmin() {
      const userData = getUserData() || {}
      const roles = [
        ...(Array.isArray(userData.roles) ? userData.roles : []),
        ...(Array.isArray(userData.role) ? userData.role : []),
        ...(typeof userData.role === 'string' ? [userData.role] : []),
      ].map(role => String(role).toLowerCase())

      return roles.includes('admin')
    },
  },
}
</script>
